function stock() {
  var popup = document.getElementById("alert_msg");
  popup.classList.toggle("show");
}
// When the user clicks on div, open the popup

jQuery(document).ready(function(){
  var winWidth = $(window).width();
    if(winWidth < 768 ){
    	$('.product_container').removeClass('product-img-box');

        $(window).scroll(function(){
//           console.log($(this).scrollTop());
          if(($(this).scrollTop()> 300) && ($(this).scrollTop()<= 8400)){ 
            $(".staticBar").show();
          }
          else
          {
            $(".staticBar").hide();
          }
        });

    }
    $('.picture-product').slick({
      slidesToShow: 2,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1
          }
        }
      ]
});
  
  $('.ann_slick').slick({
      slidesToShow: 3,
      arrows: false,
      autoplay:true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            fade: true,
            speed: 500,
            infinite: true,
            cssEase: 'ease-in-out',
          }
        }
      ]
  });
  });

jQuery(document).ready(function(){
  $('.template-index .search_mobile .ico_search').hide();
  $(window).scroll(function(){
    
  	var topHeight= $(window).scrollTop();
    var headerHeigth = $('.hd_mobile').height();
    var annHeight = $('announce_wrapper').height();
    var totalHeight = headerHeigth + annHeight;
    
    if(topHeight > 30){
  		$('.search_mobile .ico_search').show();
    }
    else
    {
  		$('.template-index .search_mobile .ico_search').hide();
      	$('.search_mobile.dropdown').removeClass('open');
    }
    
  });
  $('.cartToggle .first').hide();
  
  	$('.vp_popup').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false
    });

});

(function($) {
  if ($(".collection-sidebar")) {
    //work only in collection page
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!ella.isSidebarAjaxClick) {
        ella.sidebarParams();
        var newurl = ella.sidebarCreateUrl();
        ella.sidebarGetContent(newurl);
        ella.reActivateSidebar();
      }
      ella.isSidebarAjaxClick = false;
    });
  }

  if (window.use_color_swatch) {
    $('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    });

    // (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
    // See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options

    Shopify.optionsMap = {};

    Shopify.updateOptionsInSelector = function(selectorIndex) {

      switch (selectorIndex) {
        case 0:
          var key = 'root';
          var selector = $('.single-option-selector:eq(0)');
          break;
        case 1:
          var key = $('.single-option-selector:eq(0)').val();
          var selector = $('.single-option-selector:eq(1)');
          break;
        case 2:
          var key = $('.single-option-selector:eq(0)').val();
          key += ' / ' + $('.single-option-selector:eq(1)').val();
          var selector = $('.single-option-selector:eq(2)');
      }

      var initialValue = selector.val();
      selector.empty();
      var availableOptions = Shopify.optionsMap[key];
      if (availableOptions && availableOptions.length) {
        for (var i = 0; i < availableOptions.length; i++) {
          var option = availableOptions[i];
          var newOption = $('<option></option>').val(option).html(option);
          selector.append(newOption);
        }
        $('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
          if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
            $(this).removeClass('soldout').show().find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
          } else {
            $(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled', 'disabled');
          }
        });
        if ($.inArray(initialValue, availableOptions) !== -1) {
          selector.val(initialValue);
        }
        selector.trigger('change');
      }
    };

    Shopify.linkOptionSelectors = function(product) {
      // Building our mapping object.
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
          // Gathering values for the 1st drop-down.
          Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
          Shopify.optionsMap['root'].push(variant.option1);
          Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
          // Gathering values for the 2nd drop-down.
          if (product.options.length > 1) {
            var key = variant.option1;
            Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
            Shopify.optionsMap[key].push(variant.option2);
            Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
          }
          // Gathering values for the 3rd drop-down.
          if (product.options.length === 3) {
            var key = variant.option1 + ' / ' + variant.option2;
            Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
            Shopify.optionsMap[key].push(variant.option3);
            Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
          }
        }
      }
      // Update options right away.
      Shopify.updateOptionsInSelector(0);
      if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
      // When there is an update in the first dropdown.
      $(".single-option-selector:eq(0)").change(function() {
        Shopify.updateOptionsInSelector(1);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
      });
      // When there is an update in the second dropdown.
      $(".single-option-selector:eq(1)").change(function() {
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
      });

    };
  }

  $(document).ready(function() {
    ella.init();
    $('.cart-close').click(function(e){
      e.preventDefault();
      $(".dropdown-cart").removeClass('open');
      $('body').removeClass('cart-open');
    });
  });
  
  jQuery('body').on('change', '.grid-add select', function(e){
    e.preventDefault();
    $('option:selected', this).addClass('selected-now');
    var $form = $(this).parents('form');
    var variant_id = $form.find('select[name=id]').val();
    var variant_name = $form.find('select[name=id] option:selected').text();

    var quantity = 1;
    var title = $(this).parents('.product-item').find('.product-title').html();
    var image = $(this).parents('.product-item').find('.pr-swp-img').attr('src');
    
    $form.find('.apndnam').remove();
    

    ella.doAjaxAddToCart(variant_id, quantity, title, image);

    
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    
    
    $.post('/cart/add.json', $(this).serialize()).done(function(cart){
      //ella.updateDropdownCart();
      console.log('test');
    })
    .fail(function(){

    })
    .always(function(){
      /*var valuer = $('.selected-now').val();
      $.getJSON('/cart.json', function(cart){
        for(num in cart.items){
          $('option#'+cart.items[num].id+'').text('In Your Bag - '+ cart.items[num].variant_title +'');
        }
      });*/

      $form.prepend('<div class="apndnam">IN YOUR BAG! <span class="v-s">' +variant_name+ '</span> </div>');
      
      $('.selected-now').parent('select').css({
        background: '#D0C6BB',
        color: '#000'
      });
    });
  });

  $(window).resize(function() {
    //         ella.initMobileMenu();
    //ella.initMobileSidebar();
    //         ella.initResizeImage();

  });

  $(window).scroll(function() {
    if ($(this).scrollTop() > 200) {
      $('#back-top').fadeIn();
    } else {
      $('#back-top').fadeOut();
    }
  });

  if (!$(".header-mobile").is(":visible")) {
    $(document).on('click touchstart', function(e) {
      var quickview = $(".quick-view");
      var dropdowncart = $(".dropdown-cart");
      var cartButton = $(".cartToggle");
      var newsletter = $("#email-modal .modal-window");
      var searchBar = $(".nav-search");
      //close quickview and dropdowncart when clicking outside
      if (!quickview.is(e.target) && quickview.has(e.target).length === 0 && !dropdowncart.is(e.target) && dropdowncart.has(e.target).length === 0 && !cartButton.is(e.target) && cartButton.has(e.target).length === 0 && !newsletter.is(e.target) && newsletter.has(e.target).length === 0 && !searchBar.is(e.target) && searchBar.has(e.target).length === 0) {
        ella.closeQuickViewPopup();
        ella.closeDropdownCart();
        ella.closeEmailModalWindow();
        ella.closeDropdownSearch();
      }
    });
  }

  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      ella.closeQuickViewPopup();
      ella.closeDropdownCart();
      ella.closeDropdownSearch();
      clearTimeout(ella.ellaTimeout);
      if ($('.modal').is(':visible')) {
        $('.modal').fadeOut(500);
      }
    }
  });

  var ella = {
    ellaTimeout: null,
    isSidebarAjaxClick: false,
    init: function() {
      this.initColorSwatchGrid();
      this.initSidebar();
      this.initMobileSidebar();
      this.initScrollTop();
      this.initQuickView();
      this.initProductMoreview();
      this.initAddToCart();
      this.initModal();
      this.initProductAddToCart();
      this.initDropDownCart();
      this.initDropdownSearch();
      this.initToggleCollectionPanel();
      this.initWishlist();
      this.initProductWishlist();
      this.initRemoveWishlist();
      this.initInfiniteScrolling();
      this.product_slick();
      this.header_mobile();
      this.sidebarInitToggle();
      this.hide_filter();
      this.initoptionsize();
      this.cookie_popup();
      if($('.brands-page').length) {
        this.Page_brands();
      };
      this.initWishList();
      this.initStickyAddtoCart();
      if($('.template-cart').length) {
      this.changeQttCart();
      }
    },
    sidebarMapTagEvents: function() {
      $('.sidebar-tag a:not(".clear"), .sidebar-tag label').click(function(e) {
        var currentTags = [];
        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');
        }

        //one selection or multi selection
        if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
          //remove other selection first
          var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
          if (otherTag.length > 0) {
            var tagName = otherTag.val();
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {
                //remove tag
                currentTags.splice(tagPos, 1);
              }
            }
          }
        }

        var tagName = $(this).prev().val();
        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {
            //tag already existed, remove tag
            currentTags.splice(tagPos, 1);
          } else {
            //tag not existed
            currentTags.push(tagName);
          }
        }
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        ella.sidebarAjaxClick();
        e.preventDefault();
      });
    },
    sidebarMapCategories: function() {
      $(".collection-sidebar .sidebar-links a").click(function(e) {
        if (!$(this).hasClass('active')) {
          delete Shopify.queryParams.q;
          ella.sidebarAjaxClick($(this).attr('href'));

          //activate selected category
          $(".sidebar-links a.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },
    sidebarMapView: function() {
      $(".view-mode > span").click(function(e) {
        if (!$(this).hasClass("active")) {
          var paging = $(".filter-show > button span").text();
          if ($(this).hasClass("list")) {
            Shopify.queryParams.view = "list" + paging;
          } else {
            Shopify.queryParams.view = paging;
          }

          ella.sidebarAjaxClick();
          $(".view-mode span.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },
    sidebarMapShow: function() {
      $(".filter-show a").click(function(e) {
        if (!$(this).parent().hasClass("active")) {
          var thisPaging = $(this).attr('href');

          var view = $(".view-mode a.active").attr("href");
          if (view == "list") {
            Shopify.queryParams.view = "list" + thisPaging;
          } else {
            Shopify.queryParams.view = thisPaging;
          }

          ella.sidebarAjaxClick();
          $(".filter-show > button span").text(thisPaging);
          $(".filter-show li.active").removeClass("active");
          $(this).parent().addClass("active");
        }
        e.preventDefault();
      });
    },
    sidebarInitToggle: function() {
      $('.sidebar_toggle .widget-title').addClass('click');
      $(".sidebar_toggle .widget-title h3").off().click(function() {


        var $title = $(this).parents('.widget-title');

        if ($title.hasClass('click')) {
          $title.removeClass('click');

        } else {
          $title.addClass('click');

        }

        $(this).parents(".sidebar_toggle").find(".widget-content").slideToggle();

      });
    },
    sidebarMapSorting: function(e) {
      $(".filter-sortby li span").click(function(e) {
        if (!$(this).parent().hasClass("active")) {
          Shopify.queryParams.sort_by = $(this).attr("data-href");
          ella.sidebarAjaxClick();
          var sortbyText = $(this).text();
          $(".filter-sortby > button span").text(sortbyText);
          $(".filter-sortby li.active").removeClass("active");
          $(this).parent().addClass("active");
        }
        e.preventDefault();
      });
    },
    sidebarMapPaging: function() {
      $(".template-collection .pagination-page a").click(function(e) {
        var page = $(this).attr("href").match(/page=\d+/g);
        if (page) {
          Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
          if (Shopify.queryParams.page) {
            var newurl = ella.sidebarCreateUrl();
            ella.isSidebarAjaxClick = true;
            History.pushState({
              param: Shopify.queryParams
            }, newurl, newurl);
            ella.sidebarGetContent(newurl);
            //go to top
            $('body,html').animate({
              scrollTop: 50
            },  -300);
          }
        }
        e.preventDefault();
      });
    },
    sidebarMapClearAll: function() {
      //clear all selection
      $('.refined-widgets a.clear-all').click(function(e) {
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        ella.sidebarAjaxClick();
        e.preventDefault();
      });
    },
    sidebarMapClear: function() {
      $(".sidebar-tag").each(function() {
        var sidebarTag = $(this);
        if (sidebarTag.find("input:checked").length > 0) {
          //has active tag
          sidebarTag.find(".clear").show().click(function(e) {
            console.log("im clicked");
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            sidebarTag.find("input:checked").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  //remove tag
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            ella.sidebarAjaxClick();
            e.preventDefault();
          });
        }
      });
    },
    sidebarMapEvents: function() {
      ella.sidebarMapTagEvents();
      ella.sidebarMapCategories();
      ella.sidebarMapView();
      ella.sidebarMapShow();
      ella.sidebarMapSorting();
    },
    reActivateSidebar: function() {
      $(".sidebar-custom .active, .sidebar-links .active").removeClass("active");
      $(".sidebar-tag input:checked").attr("checked", false);

      //category
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".sidebar-links a[href='" + cat[0] + "']").addClass("active");
      }

      //view mode and show filter
      if (Shopify.queryParams.view) {
        $(".view-mode .active").removeClass("active");
        var view = Shopify.queryParams.view;
        if (view.indexOf("list") >= 0) {
          $(".view-mode .list").addClass("active");
          //paging
          view = view.replace("list", "");
        } else {
          $(".view-mode .grid").addClass("active");
        }
        $(".filter-show > button span").text(view);
        $(".filter-show li.active").removeClass("active");
        $(".filter-show a[href='" + view + "']").parent().addClass("active");
      }
      ella.initSortby();
    },
    initSortby: function() {
      //sort by filter
      if (Shopify.queryParams.sort_by) {
        var sortby = Shopify.queryParams.sort_by;
        var sortbyText = $(".staticBar .filter-sortby span[data-href='" + sortby + "']").text();
//         console.log(sortbyText);
        $('.filter-sortby > button span.text').text(sortbyText);
        $('.filter-sortby li.active').removeClass("active");
        $(".filter-sortby span[data-href='" + sortby + "']").parent().addClass("active");
      }

      else {
        var sortbyText = $(".staticBar .filter-sortby .dropdown-menu .active").text();

        $('.filter-sortby > button span.text').text(sortbyText);
      }
    },
    sidebarMapData: function(data) {
      var currentList = $(".col-main .products-grid");
      if (currentList.length == 0) {
        currentList = $(".col-main .product-list");
      }
      var productList = $(data).find(".col-main .products-grid");
      if (productList.length == 0) {
        productList = $(data).find(".col-main .product-list");
      }
      currentList.replaceWith(productList);
      //convert currency
      if (ella.checkNeedToConvertCurrency()) {
        Currency.convertAll(window.shop_currency, jQuery('.currencies').val(), '.col-main span.money', 'money_format');
      }

      //replace paging
      if ($(".padding").length > 0) {
        $(".padding").replaceWith($(data).find(".padding"));
      } else {
        $(".block-row.col-main").append($(data).find(".padding"));
      }

      //replace title & description
      var currentHeader = $(".page-header");
      var dataHeader = $(data).find(".page-header");
      if (currentHeader.find("h2").text() != dataHeader.find("h2").text()) {
        currentHeader.find("h2").replaceWith(dataHeader.find("h2"));

        var currentDes = $(".collection-des");
        var dataDes = $(data).find(".collection-des");

        if (currentDes.find(".rte").length) {
          if (dataDes.find(".rte").length) {
            currentDes.html(dataDes.find(".rte"));
          } else {
            currentDes.find(".rte").hide();
          }
        } else {
          currentDes.html(dataDes.find(".rte"));
        }

        var currentImg = $(".collection-img");
        var dataImg = $(data).find(".collection-img");
        if (currentImg.find("p").length) {
          if (dataImg.find("p").length) {
            currentImg.html(dataImg.find("p"));
          } else {
            currentImg.find("p").hide();
          }
        } else {
          currentImg.html(dataImg.find("p"));
        }
      }

      //replace refined
      $(".refined-widgets").replaceWith($(data).find(".refined-widgets"));

      //replace tags
      $(".sidebar-block").replaceWith($(data).find(".sidebar-block"));

      // breadcrumb
      $(".breadcrumb .bd-title").replaceWith($(data).find(".breadcrumb .bd-title"));
      $(".img_cart").replaceWith($(data).find(".img_cart"));

      ella.initColorSwatchGrid();

      //product review
      if ($(".spr-badge").length > 0) {
        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
      }
    },
    sidebarCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {
        //location.href = baseLink + "?" + newQuery;
        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },
    sidebarAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = ella.sidebarCreateUrl(baseLink);
      ella.isSidebarAjaxClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      ella.sidebarGetContent(newurl);
    },
    sidebarGetContent: function(newurl) {
      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          ella.showLoading();
        },
        success: function(data) {
          ella.sidebarMapData(data);
          ella.sidebarMapPaging();
          ella.translateBlock(".main-content");
          ella.sidebarMapTagEvents();
          ella.sidebarInitToggle();
          ella.sidebarMapClear();
          ella.sidebarMapClearAll();
          ella.hideLoading();

          ella.initQuickView();
          ella.initAddToCart();
          ella.initWishlist();
          ella.initInfiniteScrolling();
          ella.hide_filter();
          ella.initoptionsize();

        },
        error: function(xhr, text) {
          ella.hideLoading();
          $('.loading-modal').hide();
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          ella.showModal('.ajax-error-modal');
        }
      });
    },
    sidebarParams: function() {
      Shopify.queryParams = {};
      //get after ?...=> Object {q: "Acme"} 
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },
    initMobileSidebar: function() {
      $('.sidebar-mb a').click(function(event) {
        //               event.preventDefault();
        if ($('.sidebar').is(":hidden")) {

          $('.sidebar').slideToggle(500);
          $('body,html').animate({
            scrollTop: 200
          }, 600);
          $(this).toggleClass('hidden-arrow-left');
          $(this).html('<span>'+ window.hide_sidebar + '<i class="fa fa-chevron-up"></i></span>');

        } else {
          $('.sidebar').slideToggle(500);
          $(this).removeClass('hidden-arrow-left');
          $(this).html('<span>'+ window.show_sidebar + '<i class="fa fa-chevron-down"></i></span>');
        }
      });
    },
    initSidebar: function() {
      //if category page then init sidebar
      if ($(".collection-sidebar").length >= 0) {
        ella.sidebarParams();
        ella.initSortby();
        ella.sidebarMapEvents();
        ella.sidebarMapPaging();
        ella.sidebarInitToggle();
        ella.sidebarMapClear();
        ella.sidebarMapClearAll();
      }
    },
    initWishlist: function() {
      $('.grid-item button.wishlist').click(function(e) {
        e.preventDefault();
        var form = $(this).parent();
        var item = form.parents('.grid-item');
        $.ajax({
          type: 'POST',
          url: '/contact',
          data: form.serialize(),
          beforeSend: function() {
            ella.showLoading();
          },
          success: function(data) {
            ella.hideLoading();
            form.html('<a class="wishlist" href="/pages/wishlist" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
            var title = item.find('.product-title').html();
            var image = item.find('a > img').attr('src');
            $('.ajax-success-modal').find('.ajax-product-title').html(title);
            $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
            $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
            $('.ajax-success-modal').find('.btn-go-to-cart').hide();
            ella.showModal('.ajax-success-modal');
          },
          error: function(xhr, text) {
            ella.hideLoading();
            $('.loading-modal').hide();
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
            ella.showModal('.ajax-error-modal');
          }
        });
      });
    },
    initProductWishlist: function() {
      $('.product button.wishlist').click(function(e) {
        e.preventDefault();
        var form = $(this).parent();
        var item = form.parents('.grid-item');
        $.ajax({
          type: 'POST',
          url: '/contact',
          data: form.serialize(),
          beforeSend: function() {
            ella.showLoading();
          },
          success: function(data) {
            ella.hideLoading();
            form.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
            var title = $('.product-title h2').html();
            var image = $('#product-featured-image').attr('src');
            $('.ajax-success-modal').find('.ajax-product-title').html(title);
            $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
            $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
            $('.ajax-success-modal').find('.btn-go-to-cart').hide();
            ella.showModal('.ajax-success-modal');
          },
          error: function(xhr, text) {
            ella.hideLoading();
            $('.loading-modal').hide();
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
            ella.showModal('.ajax-error-modal');
          }
        });
      });
    },
    initRemoveWishlist: function() {
      $('.btn-remove-wishlist').click(function(e) {
        var row = $(this).parents('tr');
        var tagID = row.find('.tag-id').val();
        var form = jQuery('#remove-wishlist-form');
        form.find("input[name='contact[tags]']").val('x' + tagID);
        $.ajax({
          type: 'POST',
          url: '/contact',
          data: form.serialize(),
          beforeSend: function() {
            ella.showLoading();
          },
          success: function(data) {
            ella.hideLoading();
            row.fadeOut(1000);
          },
          error: function(xhr, text) {
            ella.hideLoading();
            $('.loading-modal').hide();
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
            ella.showModal('.ajax-error-modal');
          }
        });
      });
    },
    initColorSwatchGrid: function() { 
      jQuery('.item-swatch li label').hover(function(){
        var newImage = jQuery(this).parent().find('.hidden a').attr('href');
        jQuery(this).parents('.grid-item').find('.product-grid-image img').attr({ src: newImage }); 
        return false;
      });
    },
    initInfiniteScrolling: function() {
      if ($('.infinite-scrolling').length > 0) {
        $('.infinite-scrolling a').click(function(e) {
          e.preventDefault();
          if (!$(this).hasClass('disabled')) {
            ella.doInfiniteScrolling();
          }
        });
      }

      window.infinitPos = 0;
      $(window).scroll(function(event) {
        if ($(".infinite-scrolling").length>0) {
          var pos = $(".infinite-scrolling").offset().top;
          if ($(this).scrollTop() > (pos - 600) && $(".infinite-scrolling").length>0
              && $(".infinite-scrolling a:eq(0)").is(":visible")
              && $(this).scrollTop() - window.infinitPos > 1000
             ) {
            window.infinitPos = $(this).scrollTop();
            $(".infinite-scrolling a").trigger("click");
            event.stopPropagation();
            event.preventDefault();
          }
        }
      });
    },
    doInfiniteScrolling: function() {
      var currentList = $('.block-row .products-grid');
      if (!currentList.length) {
        currentList = $('.block-row .product-list');
      }
      if (currentList) {
        var showMoreButton = $('.infinite-scrolling a').first();
        $.ajax({
          type: 'GET',
          url: showMoreButton.attr("href"),
          beforeSend: function() {
            ella.showLoading();
            $('.loading-modal').show();
            showMoreButton.hide();
          },
          success: function(data) {
            ella.hideLoading();
            showMoreButton.show();
            var products = $(data).find(".block-row .products-grid");
            if (!products.length) {
              products = $(data).find(".block-row .product-list");
            }
            if (products.length) {

              currentList.append(products.children());
              ella.translateBlock("." + currentList.attr("class"));
              ella.initQuickView();
              ella.initAddToCart();
              ella.initWishlist();
              ella.initoptionsize();
              //get link of Show more
              if ($(data).find('.infinite-scrolling').length > 0) {
                showMoreButton.attr('href', $(data).find('.infinite-scrolling a').attr('href'));
              } else {
                //no more products
                showMoreButton.hide();
                showMoreButton.next().show();
              }

              //currency
              if (window.show_multiple_currencies && window.shop_currency != jQuery(".currencies").val())
              {
                Currency.convertAll(window.shop_currency, jQuery(".currencies").val(), "span.money", "money_format")
              }

              ella.initColorSwatchGrid();

              //product review
              if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              }
            }
          },
          error: function(xhr, text) {
            ella.hideLoading();
            $('.loading-modal').hide();
            $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
            ella.showModal('.ajax-error-modal');
          },
          dataType: "html"
        });
      }
    },
    closeEmailModalWindow: function() {
      if ($('#email-modal').length > 0 && $('#email-modal').is(':visible')) {
        $('#email-modal .modal-window').fadeOut(600, function() {
          $('#email-modal .modal-overlay').fadeOut(600, function() {
            $('#email-modal').hide();
            $.cookie('emailSubcribeModal', 'closed', {
              expires: 1,
              path: '/'
            });
          });
        });
      }
    },
    showModal: function(selector) {
      $(selector).fadeIn(500)
      ella.ellaTimeout = setTimeout(function() {
        $(selector).fadeOut(500);
      }, 5000);
    },
    initToggleCollectionPanel: function() {
      if ($('.collection-sharing-btn').length > 0) {
        $('.collection-sharing-btn').click(function() {
          $('.collection-sharing-panel').toggle();
          if ($('.collection-sharing-panel').is(':visible')) {
            $('.collection-sharing-btn').addClass('btn-hover');
            $('.collection-filter-panel').hide();
            $('.collection-filter-btn').removeClass('btn-hover');
          } else {
            $('.collection-sharing-btn').removeClass('btn-hover');
          }
        });
      }
      if ($('.collection-filter-btn').length > 0) {
        $('.collection-filter-btn').click(function() {
          $('.collection-filter-panel').toggle();
          if ($('.collection-filter-panel').is(':visible')) {
            $('.collection-filter-btn').addClass('btn-hover');
            $('.collection-sharing-panel').hide();
            $('.collection-sharing-btn').removeClass('btn-hover');
          } else {
            $('.collection-filter-btn').removeClass('btn-hover');
          }
        });
        $('.collection-filter-panel select').change(function(index) {
          window.location = $(this).find('option:selected').val();
        });
      }
    },
    checkItemsInDropdownCart: function() {
      if ($('.dropdown-cart .mini-products-list').children().length > 0) {
        //Has item in dropdown cart
        $('.dropdown-cart .no-items').hide();
        $('.dropdown-cart .has-items').show();
      } else {
        //No item in dropdown cart                
        $('.dropdown-cart .has-items').hide();
        $('.dropdown-cart .no-items').show();
      }
    },
    initModal: function() {
      $('.continue-shopping').click(function() {
        clearTimeout(ella.ellaTimeout);
        $('.ajax-success-modal').fadeOut(500);
      });
      $('.close-modal, .overlay').click(function() {
        clearTimeout(ella.ellaTimeout);
        $('.ajax-success-modal').fadeOut(500);
      });
    },
    initDropDownCart: function() {
      if (window.dropdowncart_type == "click") {
        //click type  
        $('.cartToggle').click(function() {
          /*if ($('.dropdown-cart').is(':visible')) {
            $(".dropdown-cart").slideUp('fast');
          } else {
            $(".dropdown-cart").slideDown('fast');
          }*/
          if ($('.dropdown-cart').hasClass('open')) {
            $(".dropdown-cart").removeClass('open');
            $('body').removeClass('cart-open');
          } else {
            $(".dropdown-cart").addClass('open');
             $('body').addClass('cart-open');
          }
        });
      } else {
        //hover type
        if (!('ontouchstart' in document)) {
          $('.cartToggle').hover(function() {
            if (!$('.dropdown-cart').is(':visible')) {
              $(".dropdown-cart").slideDown('fast');
            }
          });
          $('.wrapper-top-cart').mouseleave(function() {
            $(".dropdown-cart").slideUp('fast');
          });
        } else {
          //mobile
          $('.cartToggle').click(function() {
            if ($('.dropdown-cart').is(':visible')) {
              $(".dropdown-cart").slideUp('fast');
            } else {
              $(".dropdown-cart").slideDown('fast');
            }
          });
        }
      }

      //ella.checkItemsInDropdownCart();

      $('.dropdown-cart .no-items a').click(function() {
        $(".dropdown-cart").slideUp('fast');
      });

      $('.dropdown-cart .btn-remove').click(function(event) {
        event.preventDefault();
        var productId = $(this).parents('.item').attr('id');
        productId = productId.match(/\d+/g);
        Shopify.removeItem(productId, function(cart) {
          ella.doUpdateDropdownCart(cart);
        });
      });
      $('.dropdown-cart .theSideCartQuantity').change(function(e){
        ella.updateCartCustom($(this));
      });
      
      $(".dropdown-cart select.product-main-option").change(function() {
        var jData = {}
        var $this = $(this);
        var $item = $(this).closest('.item');
        var origId = $item.attr('id')
        var newId = $(this).val();
        var newQuantity = 1;

        $(this).closest('form').find('.item').each(function(ix,e){
          if ($(e).attr('id')==newId) {
            newQuantity += $(e).find('select.quantity').val()/1;
          }
        })
        jData[newId] = newQuantity;
        jData[origId] = $item.find('select.quantity').val()-1;
        //console.log(jData);

        var form = $(this).closest('form');
        $.ajax({
          url: '/cart/update.js',
          dataType: 'json',
          data: {updates: jData}
        }).done(function(data){
          if (jData[origId]>0) {
            var prevMainOptionText = $this.data('main-option-text');
          }

          ella.updateDropdownCart();

        }).error(function(err){
          console.log("the err", err)
        });
      });
      
    },
    closeDropdownCart: function() {
      /*if ($('.dropdown-cart').is(':visible')) {
        $(".dropdown-cart").slideUp('fast');
      }*/
      
      if ($('.dropdown-cart').hasClass('open')) {
        $(".dropdown-cart").removeClass('open');
        $('body').removeClass('cart-open');
      }
    },
    initDropdownSearch: function() {
      $('.nav-search .icon-search').click(function() {
        if ($('.header-bottom.on .search-bar').is(':visible')) {
          $('.header-bottom.on .search-bar').slideUp('fast');
        } else {
          $('.header-bottom.on .search-bar').slideDown('fast');
        }
      });
    },
    closeDropdownSearch: function() {
      if ($(".header-bottom.on .search-bar").is(":visible")) {
        $(".header-bottom.on .search-bar").slideUp("fast")
      }
    },
    initProductMoreview: function() {
      if ($('.more-view-wrapper-owlslider').length > 0) {
        this.initOwlMoreview();
      } else if ($('.more-view-wrapper-jcarousel').length > 0) {
        this.initJcarouselMoreview();
      }
    },
    initOwlMoreview: function() {
      $('.more-view-wrapper-owlslider ul').owlCarousel({
        navigation: true,
        items: 5,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [979, 3],
        itemsTablet: [768, 3],
        itemsTabletSmall: [540, 3],
        itemsMobile: [360, 3]
      }).css('visibility', 'visible');
    },
    initJcarouselMoreview: function() {
      $('.more-view-wrapper-jcarousel ul').jcarousel({
        vertical: true
      }).css('visibility', 'visible');
      $('.product-img-box').addClass('has-jcarousel');
      $('.more-view-wrapper').css('visibility', 'visible');
    },
    initCloudzoom: function() {
      if ($(window).width() >= 1025 ) {
        $('.picture-product .item-picture .fancybox').zoom();
      }
      else {    
        $('.picture-product .item-picture .fancybox').trigger('zoom.destroy');
      } 
    },
    initScrollTop: function() {
      $('#back-top').click(function() {
        $('body,html').animate({
          scrollTop: 0
        }, 400);
        return false;
      });
    },
    initProductAddToCart: function() {
      if ($('#product-add-to-cart').length > 0) {
        $('#product-add-to-cart').click(function(event) {
          event.preventDefault();
          var $this = $(this);
          if ($(this).attr('disabled') != 'disabled') {
            if($this.hasClass('notifyMe')){
              console.log("test");
              var targBtn     = document.querySelector ("#BIS_trigger");
              var clickEvent  = document.createEvent ('MouseEvents');
              clickEvent.initEvent ('click', true, true);
              targBtn.dispatchEvent (clickEvent);
              
            }else{
            if (!window.ajax_cart) {
              $(this).closest('form').submit();
            } else {
              var variant_id = $('#add-to-cart-form select[name=id]').val();
              if (!variant_id) {
                variant_id = $('#add-to-cart-form input[name=id]').val();
              }
              var quantity = $('#add-to-cart-form input[name=quantity]').val();
              if (!quantity) {
                quantity = 1;
              }
              var title = $('.product-title h2').html();
              var image = $('.picture-product .slick-current .product-featured-image').attr('src');
              ella.doAjaxAddToCart(variant_id, quantity, title, image);
            }
            }
          }
          return false;
        });
      }
    },
    initAddToCart: function() {
      if ($('.add-to-cart-btn').length > 0) {
        $('.add-to-cart-btn').click(function(event) {
          event.preventDefault();
          if ($(this).attr('disabled') != 'disabled') {
            var productItem = $(this).parents('.product-item');
            var productId = $(productItem).attr('id');
            productId = productId.match(/\d+/g);
            if (!window.ajax_cart) {
              $('#product-actions-' + productId).submit();
            } else {
              var variant_id = $('#product-actions-' + productId + ' select[name=id]').val();
              if (!variant_id) {
                variant_id = $('#product-actions-' + productId + ' input[name=id]').val();
              }
              var quantity = $('#product-actions-' + productId + ' input[name=quantity]').val();
              if (!quantity) {
                quantity = 1;
              }
              var title = $(productItem).find('.product-title').html();
              var image = $(productItem).find('.product-grid-image img').attr('src');
              ella.doAjaxAddToCart(variant_id, quantity, title, image);
            }
          }
          return false;
        });
      }
    },
    showLoading: function() {
      $('.loading-modal').show();
    },
    hideLoading: function() {
      $('.loading-modal').hide();
    },
    doAjaxAddToCart: function(variant_id, quantity, title, image) {
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        beforeSend: function() {
          ella.showLoading();
        },
        success: function(msg) {
          ella.hideLoading();
          $('.ajax-success-modal').find('.ajax-product-title').html(ella.translateText(title));
          $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
          $('.ajax-success-modal').find('.btn-go-to-wishlist').hide();
          $('.ajax-success-modal').find('.btn-go-to-cart').show();

          ella.showModal('.ajax-success-modal');
          ella.updateDropdownCart();
          
        },
        error: function(xhr, text) {
          ella.hideLoading();
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          ella.showModal('.ajax-error-modal');
        }
      });
    },
    initQuickView: function() {
      $('.quickview-button a').click(function() {
        var product_handle = $(this).attr('id');
        Shopify.getProduct(product_handle, function(product) {
          var template = $('#quickview-template').html();
          $('.quick-view').html(template);
          var quickview = $('.quick-view');
          
          quickview.find('.product-title a').html(ella.translateText(product.title));
          quickview.find('.product-title a').attr('href', product.url);
          if (quickview.find('.product-vendor span').length > 0) {
            quickview.find('.product-vendor span').text(product.vendor);
          }
          if (quickview.find('.product-type span').length > 0) {
            quickview.find('.product-type span').text(product.type);
          }
          if (quickview.find('.product-inventory span').length > 0) {
            var variant = product.variants[0];
            var inventoryInfo = quickview.find('.product-inventory span');                      
            if (variant.available) {
              if (variant.inventory_management!=null) {
                inventoryInfo.text(window.inventory_text.in_stock);
              } else {
                inventoryInfo.text(window.inventory_text.many_in_stock);
              }
            } else {
              inventoryInfo.text(window.inventory_text.out_of_stock);
            }
          }
          //countdown for quickview
          if (product.description.indexOf("[countdown]") > 0) {
            var countdownTime = product.description.match(/\[countdown\](.*)\[\/countdown\]/);
            if (countdownTime && countdownTime.length > 0) {
              quickview.find(".countdown").show();
              quickview.find(".quickview-clock").countdown(countdownTime[1], function(event) {
                $(this).html(event.strftime('%Dd %H:%M:%S'));
              });
            }
          }
          if (quickview.find('.product-description').length > 0) {
            var description = product.description;
            //var description = description.replace(/\[countdown\](.*)\[\/countdown\]/g, "");
            if (window.multi_lang) {
              if (description.indexOf("[lang2]") > 0) {
                var descList = description.split("[lang2]");
                if (jQuery.cookie("language") != null) {
                  description = descList[translator.current_lang - 1];
                } else {
                  description = descList[0];
                }
              }
            }
            //description = description.split(" ").splice(0, 20).join(" ") + "...";
            quickview.find('.product-description').html(description);
          } else {
            quickview.find('.product-description').remove();
          }

          quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));
          quickview.find('.product-item').attr('id', 'product-' + product.id);
          quickview.find('.variants').attr('id', 'product-actions-' + product.id);
          quickview.find('.variants select').attr('id', 'product-select-' + product.id);

          //if has compare price
          if (product.compare_at_price > product.price) {
            quickview.find('.compare-price').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
            quickview.find('.price').addClass('on-sale');
          } else {
            quickview.find('.compare-price').html('');
            quickview.find('.price').removeClass('on-sale');
          }

          //out of stock
          if (!product.available) {
            quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
            quickview.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass('disabled').attr("disabled", "disabled");;
          } else {
            quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));
            if (window.use_color_swatch) {
              ella.createQuickViewVariantsSwatch(product, quickview);
            } else {
              ella.createQuickViewVariants(product, quickview);
            }
          }

          //quantity
          quickview.find(".button").on("click", function() {
            var oldValue = quickview.find(".quantity").val(),
                newVal = 1;
            if ($(this).text() == "+") {
              newVal = parseInt(oldValue) + 1;
            } else if (oldValue > 1) {
              newVal = parseInt(oldValue) - 1;
            }
            quickview.find(".quantity").val(newVal);

            if (quickview.find(".total-price").length > 0) {
              ella.updatePricingQuickview();
            }
          });

          if (window.show_multiple_currencies) {
            Currency.convertAll(window.shop_currency, jQuery('.currencies').val(), 'span.money', 'money_format');
          }

          ella.loadQuickViewSlider(product, quickview);
          ella.initQuickviewAddToCart();
          ella.translateBlock(".quick-view");                    

          $('.quick-view').fadeIn(500);
          if ($('.quick-view .total-price').length > 0) {
            $('.quick-view input[name=quantity]').on('change', ella.updatePricingQuickview);
          }
          
              $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
        });

      
        
        
        return false;
      });

      $(document).on("click", ".quick-view .overlay, .close-window", function() {
        ella.closeQuickViewPopup();
        return false;
      });
    },
    updatePricingQuickview: function() {
      //try pattern one before pattern 2
      var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
      var unitPriceTextMatch = $('.quick-view .price').text().match(regex);

      if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = $('.quick-view .price').text().match(regex);
      }

      if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g, '');
        var quantity = parseInt($('.quick-view input[name=quantity]').val());
        var totalPrice = unitPrice * quantity;

        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
        if (!totalPriceText.match(regex)) {
          regex = /([0-9]+[.|,][0-9]+)/g;
        } 
        totalPriceText = totalPriceText.match(regex)[0];

        var regInput = new RegExp(unitPriceText, "g");
        var totalPriceHtml = $('.quick-view .price').html().replace(regInput, totalPriceText);

        $('.quick-view .total-price span').html(totalPriceHtml);
      }
    },
    updateCartCustom: function(elem){
      var data = elem.parents('form').serialize();
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          //async: false,
          data: data,
          dataType: 'json',
          error: function(){
            console.log('error');
          },
          success: function(){
            ella.updateDropdownCart();
           
            
            if ($('.dropdown-cart').hasClass('open')) {
              $(".dropdown-cart").removeClass('open');
              $('body').removeClass('cart-open');
            } else {
              $(".dropdown-cart").addClass('open');
              $('body').addClass('cart-open');
            }
            
          },
        });
    },
    initQuickviewAddToCart: function() {
      if ($('.quick-view .add-to-cart-btn').length > 0) {
        $('.quick-view .add-to-cart-btn').click(function() {
            var variant_id = $('.quick-view select[name=id]').val();
            if (!variant_id) {
              variant_id = $('.quick-view input[name=id]').val();
            }
            var quantity = $('.quick-view input[name=quantity]').val();
            if (!quantity) {
              quantity = 1;
            }

            var title = $('.quick-view .product-title a').html();
            var image = $('.quick-view .quickview-featured-image img').attr('src');
            ella.doAjaxAddToCart(variant_id, quantity, title, image);
            ella.closeQuickViewPopup();
        });
      }
    },
    updateDropdownCart: function() { 
      
      
      Shopify.getCart(function(cart) {
        ella.doUpdateDropdownCart(cart);
        setTimeout(function(){
          if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
          }
        }, 1000);
      });
    },
    doUpdateDropdownCart: function(cart) {
      //var template = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove">X</a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';
      //var template = '<li class="item" id="{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-product-info-container"><div class="cart-quantity-container"><select class="quantity theSideCartQuantity" name="updates[]">{QuantityOption}</select><div class="cart-main-option-ddl">{VariantSelect}</div><div class="side-cart-actions"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove">X</a></div></div><div class="cart-collateral cart-item-price-container"><span class="price">{PRICE}</span></div></div></div></li>';
      $('.cartCount').text(cart.item_count);
      /*Total price*/
      $('.dropdown-cart .summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
      /*Clear cart*/
      $('.dropdown-cart .side-cart-content').html('');

      $.get("/cart?view=ajax-cart", function(cartData){
        var newCartObj = $('<div>' + cartData + '</div>').find('.side-cart-content').html();

        var $cartShade = $(newCartObj);
        //console.log($cartShade);

        /*Add product to cart*/
          /*for (var i = 0; i < cart.items.length; i++) {
          console.log(cart.items[i]);
          var QuantityOption = "";
          var VariantSelect = "";
          if(cart.items[i].variant_options){
            VariantSelect = '<select id="product-variant-'+cart.items[i].id+'-main-option" class="product-main-option"><option value="'+cart.items[i].variant_id+'">'+cart.items[i].variant_title+ '</option></select>';
          }
          for(var j=0; j < 10; j++){
            if(cart.items[i].quantity == j){
            QuantityOption += '<option selected="selected">'+j+'</option>';
            }else{
              QuantityOption += '<option>'+j+'</option>';
            }
          }
          var item = template;
          item = item.replace(/\{ID\}/g, cart.items[i].id);
          item = item.replace(/\{URL\}/g, cart.items[i].url);
          item = item.replace(/\{TITLE\}/g, ella.translateText(cart.items[i].title));
          item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
          item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
          item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
          item = item.replace(/\{QuantityOption\}/g, QuantityOption);
          item = item.replace(/\{VariantSelect\}/g, VariantSelect);
          $('.dropdown-cart .mini-products-list').append(item);
        }*/
          
          
          $('.dropdown-cart .side-cart-content').append($cartShade);

          if ($('.dropdown-cart').hasClass('open')) {
            $(".dropdown-cart").removeClass('open');
            $('body').removeClass('cart-open');
          } else {
            $(".dropdown-cart").addClass('open');
            $('body').addClass('cart-open');
          }

          $('.dropdown-cart .btn-remove').click(function(event) {
            event.preventDefault();
            var productId = $(this).parents('.item').attr('id');
            productId = productId.match(/\d+/g);
            Shopify.removeItem(productId, function(cart) {
              ella.doUpdateDropdownCart(cart);
              
              setTimeout(function(){
                if (window.Shopify && Shopify.StorefrontExpressButtons) {
                  Shopify.StorefrontExpressButtons.initialize();
                }
              }, 1000);
              
              if ($('.dropdown-cart').hasClass('open')) {
                $(".dropdown-cart").removeClass('open');
                $('body').removeClass('cart-open');
              } else {
                $(".dropdown-cart").addClass('open');
                $('body').addClass('cart-open');
              }
              
            });
          });

          $('.dropdown-cart .theSideCartQuantity').change(function(e){
            ella.updateCartCustom($(this));
          });

          $(".dropdown-cart select.product-main-option").change(function() {
            var jData = {}
            var $this = $(this);
            var $item = $(this).closest('.item');
            var origId = $item.attr('id')
            var newId = $(this).val();
            var newQuantity = 1;

            $(this).closest('form').find('.item').each(function(ix,e){
              if ($(e).attr('id')==newId) {
                newQuantity += $(e).find('select.quantity').val()/1;
              }
            })
            jData[newId] = newQuantity;
            jData[origId] = $item.find('select.quantity').val()-1;

            var form = $(this).closest('form');
            $.ajax({
              url: '/cart/update.js',
              dataType: 'json',
              data: {updates: jData}
            }).done(function(data){
              if (jData[origId]>0) {
                var prevMainOptionText = $this.data('main-option-text');
              }

              ella.updateDropdownCart();
            }).error(function(err){
              console.log("the err", err)
            });
          });

          if (ella.checkNeedToConvertCurrency()) {
            Currency.convertAll(window.shop_currency, jQuery('.currencies').val(), '.dropdown-cart span.money', 'money_format');
          }
      }, 'html');
      //ella.checkItemsInDropdownCart();
    },
    
    checkNeedToConvertCurrency: function() {
      return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
    },
    loadQuickViewSlider: function(product, quickviewTemplate) {
      var product_container = quickviewTemplate.find('.quickview-featured-image');
      var count = 0;
      for (i in product.images) {
        if (count < product.images.length) {
          var featuredImage = Shopify.resizeImage(product.images[i], 'grande');

          var item = '<div class="qv_item"><a href="' + product.url + '"><img src="' + featuredImage + '" title="' + product.title + '" /></a></div>'

          product_container.append(item);
          count = count + 1;
        }
      }

      var product_thumbnails = quickviewTemplate.find('.more-view-wrapper ul');
      var count = 0;
      for (i in product.images) {
        if (count < product.images.length) {
          var grande = Shopify.resizeImage(product.images[i], 'grande');
          var compact = Shopify.resizeImage(product.images[i], 'compact');
          var item = '<li class="grid-item"><a href="javascript:void(0)" data-image="' + grande + '"><img src="' + compact + '"  /></a></li>'

          product_thumbnails.append(item);
          count = count + 1;
        }
      }
      setTimeout(function() {
        ella.image_product_slick(product_container, product_thumbnails);
      }, 500);


    },
    convertToSlug: function(text) {
      return text
      .toLowerCase()
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    },
    createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
      if (product.variants.length > 1) { //multiple variants
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
          quickviewTemplate.find('form.variants > select').append(option);
        }
        new Shopify.OptionSelectors("product-select-" + product.id, {
          product: product,
          onVariantSelected: selectCallbackQuickview
        });

        //start of quickview variant;
        var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
        var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
        var options = "";
        for (var i = 0; i < product.options.length; i++) {
          options += '<div class="swatch clearfix" data-option-index="' + i + '">';
          options += '<div class="header">' + product.options[i].name + '</div>';
          var is_color = false;
          if (/Color|Colour/i.test(product.options[i].name)) {
            is_color = true;
          }
          var optionValues = new Array();
          for (var j = 0; j < product.variants.length; j++) {
            var variant = product.variants[j];
            var value = variant.options[i];
            var valueHandle = this.convertToSlug(value);
            var forText = 'swatch-' + i + '-' + valueHandle;

            if(variant.featured_image != null && window.use_variant_swatch== true){
              var variant_swatch = variant.featured_image.src;
            }else{
              var variant_swatch = filePath + valueHandle +'.png';
            }


            if (optionValues.indexOf(value) < 0) {
              //not yet inserted
              options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';

              if (is_color) {
                options += '<div class="tooltip">' + value + '</div>';
              }
              options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';

              if (is_color) {
                options += '<label for="' + forText + '" style="background-color: ' + valueHandle + ';background-size: cover; background-image: url(' + variant_swatch+ ')"><img class="crossed-out" src="' + assetUrl + 'soldout.png" /></label>';
              } else {
                options += '<label for="' + forText + '">' + value + '<img class="crossed-out" src="' + assetUrl + 'soldout.png" /></label>';
              }
              options += '</div>';
              if (variant.available) {
                $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
              }
              optionValues.push(value);
            }
          }
          options += '</div>';
        }
        quickviewTemplate.find('form.variants > select').after(options);
        quickviewTemplate.find('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
        });
        if (product.available) {
          Shopify.optionsMap = {};
          Shopify.linkOptionSelectors(product);
        }

        //end of quickview variant
      } else { //single variant
        quickviewTemplate.find('form.variants > select').remove();
        var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
        quickviewTemplate.find('form.variants').append(variant_field);
      }
    },
    createQuickViewVariants: function(product, quickviewTemplate) {
      if (product.variants.length > 1) { //multiple variants
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
          quickviewTemplate.find('form.variants > select').append(option);
        }

        new Shopify.OptionSelectors("product-select-" + product.id, {
          product: product,
          onVariantSelected: selectCallbackQuickview
        }); 

        if (product.options.length == 1) {
          $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
          for (var text = product.variants, r = 0; r < text.length; r++ ) {
            var s = text[r];
            if (!s.available) {
              jQuery('.single-option-selector option').filter(function() { return jQuery(this).html() === s.title }).remove();
            }
          };
        }
        
        $('.quick-view .single-option-selector').selectize();
        $('.quick-view .selectize-input input').attr("disabled", "disabled");

        quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i, v) {
          $(this).html(product.options[i].name);
        });
      } else { //single variant
        quickviewTemplate.find('form.variants > select').remove();
        var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
        quickviewTemplate.find('form.variants').append(variant_field);
      }

    },
    closeQuickViewPopup: function() {
      $('.quick-view').fadeOut(500);
    },
    translateText: function(str) {
      if (!window.multi_lang || str.indexOf("|") < 0)
        return str;

      if (window.multi_lang) {
        var textArr = str.split("|");
        if (translator.isLang2())
          return textArr[1];
        return textArr[0];
      }          
    },
    translateBlock: function(blockSelector) {
      if (window.multi_lang && translator.isLang2()) {
        translator.doTranslate(blockSelector);
      }
    },

    image_product_slick: function(product_container, product_thumbnails){
      product_container.not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 2,
        arrows: false,
        fade: true,
        asNavFor: product_thumbnails
      });

      product_thumbnails.not('.slick-initialized').slick({
        slidesToShow: $('.product-photo-container').data('item'),
        slidesToScroll: 1,
        asNavFor: product_container,
        dots: false,
        focusOnSelect: true,
        verticalSwiping: $('.product-photo-container').data('moreview'),
        vertical: $('.product-photo-container').data('moreview'),
        responsive:[
          {
            breakpoint: 768,
            settings:{
              vertical: false
            }
          }
        ]
      });
    },
    product_slick:function(){
      var product_container = $('.product-photo-container .picture-product');
      var product_thumbnails = $('.product-thumbnails .picture-thumbnails');
      ella.image_product_slick(product_container, product_thumbnails);
      ella.initCloudzoom();
     
    },

    header_mobile:function(){
      $('.mn_mobile nav ul').html($('.site-nav').html());

      $('.mn_mobile .icon-menu, .customer-mb .ico_user').click(function() {
        if($('html').hasClass('open-mn')){
          $('html').removeClass('open-mn');
        }
        else{
          $('html').addClass('open-mn');
        }
      });



      $('.hd_mobile .customer-area .ico_user').click(function() {
        if($('html').hasClass('open-user')){
          $('html').removeClass('open-user');
        }
        else{
          $('html').addClass('open-user');
        }
      });

      $('.overlay-mn, .close_user').click(function(){
        $('html').removeClass('open-mn');
        $('html').removeClass('open-user');
      });  

      $('.hd_mobile .icon-dropdown').click(function(e){
        e.preventDefault();
        if($(this).hasClass('mobile-toggle-open')) {
          $(this).parent().next().hide();
          $(this).removeClass("mobile-toggle-open");
        }

        else {
          $(this).parent().next().show();
          $(this).addClass("mobile-toggle-open");
        }
      });

      var w = window.innerWidth;
      if (w < 1024) {
        jQuery('.hd_mobile .dropdown .menu__moblie').bind('click', function(event) {
          if (currentEl != this) {
            $(this).next().show();
            $(this).prev().addClass('mobile-toggle-open');
            $(this).find('.icon-dropdown').addClass('mobile-toggle-open');
            event.preventDefault();
            currentEl = this;
          }
        });
      }

    },
    hide_filter: function(){
      $(".sidebar-custom .widget-content ul").each(function() {   
        if ($(this).children('li').length > 0) {
          $(this).parents('.sidebar-custom').show();
        } else { 
          $(this).parents('.sidebar-custom').hide();
        }
      });
    },

    Page_brands: function(){
      $(".brands-list .brand").each(function(){
        var chi = $(this).find(".azbrands-title h3").text().trim();
        var ch = $(this).find("ul.brandgrid li:eq(0)").text().charAt(0);
        $('.azbrandstable').children().each(function(){
          if( $(this).find('a').text().trim() == chi){
            if( !$(this).find('a').hasClass('readonly') )
              $(this).find('a').addClass('readonly');
            return;
          }
        });
        if($(this).find(".azbrands-title").length == 0){

          $(this).find("ul.brandgrid").children().appendTo('.brand-' + ch + " ul.brandgrid");
          $(this).remove();
        }
      });

      $('.azbrandstable .vendor-letter a.readonly').click(function(){
        var v = $(this).text();
        $('.brands-list .brand').hide().filter(function(e){
          var n =  $(this).find('h3').text();
          return n == v;
        }).show();
        $('.azbrandstable .all-brand a').click(function(){
          $(".brands-list .brand").show();
        });
      });
      $('.azbrandstable a.readonly').click(function(){
        $('.azbrandstable a').removeClass('active');
        var $this = $(this);
        if (!$this.hasClass('active')) {
          $this.addClass('active');
        }
        var topbrand = $('.header').outerHeight();
        $('html, body').animate({scrollTop: topbrand}, 400);
      });

      $('.logo-brands').each(function(){
        var brand_slider =  $(this).find('.slide-logo');
        if(brand_slider.length){
          brand_slider.not('.slick-initialized').slick({
            slidesToShow: brand_slider.data('row'),
            slidesToScroll: brand_slider.data('row'),
            arrows: true,
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
            speed : 1000,   
            dots: false,
            responsive: [
              {
                breakpoint: 1025,
                settings: {
                  slidesToShow: 6,
                  slidesToScroll: 6     
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 6,
                  slidesToScroll: 6,
                  dots: false,
                  arrows: false
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 6,
                  slidesToScroll: 6,
                  dots: false,
                  arrows: true
                }
              }
            ]
          });
        }
      });


    },

    initWishList: function(e){      
      var ListWishList = $('.wishlist-content'),
          button = $('.wishlist-btn'),
          itemsArray = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];


      localStorage.setItem('items', JSON.stringify(itemsArray));

      var data = JSON.parse(localStorage.getItem('items'));

      if (itemsArray.length > 0) {
        itemsArray = JSON.parse(localStorage.getItem('items'));       
      };

      var currentpage = 1;
      var pagecount = 0;

      ella.translateBlock(".wishlist-page");

      var dataWishlist = function(ProductHandle) {
        jQuery.getJSON('/products/'+ProductHandle+'.js', function(product) {
          var productHTML = '';
          var price_min = Shopify.formatMoney(product.price_min, window.money_format);

          productHTML += '<div class="wishlist-product-content wishlist-tile-container product-item grid-item"  data-product-handle="'+product.handle+'" data-id="'+ product.id +'">';
          productHTML += '<div class="row">';
          productHTML += '<div class="product-image col-sm-2"><a href="'+product.url +'"><image src="'+product.featured_image +'" /></a></div>';
          productHTML += '<div class="product-bottom col-sm-5">';
          productHTML += '<div class="product-vendor">'+product.vendor +'</div>'
          productHTML += '<a class="product-title" href="'+product.url +'">'+product.title+'</a>';
          productHTML += '</div>';
          productHTML += '<div class="price-box col-sm-2">'+ price_min +'</div>';
          productHTML += '<div class="col-sm-1 text-center wishlist-button"><a class="btn-active wishlist-btn" href="#" data-id="'+ product.id +'"></a></div>';
          productHTML += '<div class="col-sm-2 text-center wishlist-button"><div class="action"><form action="/cart/add" method="post" class="variants" enctype="multipart/form-data">';
          productHTML += '<input type="hidden" name="id" value="'+ product.variants[0].id +'" />  ';

          if (product.available) {
            if (product.variants.length == 1) {
              productHTML += '<input class="btn add-to-cart-btn1" type="submit" value="'+window.inventory_text.add_to_cart+'"/>'; 
            } 
            if (product.variants.length > 1 && window.innerWidth > 480){
             
              productHTML += '<a class="btn add-to-cart-btn1 cst-btn-2" href="'+product.url +'">'+'ADD TO CART'+'</a>';
            }
            if (product.variants.length > 1 && window.innerWidth < 480){
              productHTML += '<a class="btn add-to-cart-btn1 cst-btn-2" href="'+product.url +'">'+'ADD TO CART'+'</a>';
            }
            
          } else {
            productHTML += '<input class="btn add-to-cart-btn1" disabled="disabled" type="submit" value="'+window.inventory_text.unavailable+'"/>';
          }
          productHTML += '</div></form></div>';


          productHTML += '</div></div>';
          productHTML.textContent = product; 
          ListWishList.append(productHTML).html();
          var currentpage = 1;
          var pagecount = 0;
          function showpage(page) {
            $('.wishlist-page .grid-item').hide();
            $('.wishlist-page .grid-item').eq((page-1)*3).show().next().show().next().show();
            $('#pagin').find('a').removeClass('current').eq(page).addClass('current');
          }

          $(".wishlist-page #pagin").on("click", "a", function(event){

            event.preventDefault();

            if($(this).html() == "next") {
              currentpage++;
            }
            else if($(this).html() == "previous") {
              currentpage--;
            }
            else {
              currentpage = $(this).html();
            }

            if(currentpage < 1) {currentpage = 1;}

            if(currentpage > pagecount) {currentpage = pagecount;}
            showpage(currentpage);
          });

          $(document).ready(function() {
            pagecount = Math.floor(($('.wishlist-page .grid-item').size()) / 3);
            if (($('.wishlist-page .grid-item').size()) % 3 > 0) {
              pagecount++;
            }

            $('.wishlist-page #pagin').html('<li><a>previous</a></li>');

            for (var i = 1; i <= pagecount; i++) {
              $('#pagin').append('<li><a class="current">' + i + '</a></li>');
            }

            $('.wishlist-page #pagin').append('<li><a>next</a></li>');

            showpage(1);
          });

        });        
      };

      var updateWishlist = function (self) {
        var ProductHandle = $(self).attr('data-product-handle');

        jQuery.getJSON('/products/'+ProductHandle+'.js', function(product) {
          itemsArray.push(ProductHandle);
          localStorage.setItem('items', JSON.stringify(itemsArray));
          dataWishlist(ProductHandle); 

          var x = itemsArray.length;  

          $('.wishlist .wishCount').text(x);
        });
      };

      var le = function (self){
        var x = itemsArray.length; 

        $('.wishlist .wishCount').text(x);
      };

      data.forEach(function(item) {
        dataWishlist(item);
      });

      $(document).on('click', '.wishlist-btn:not(.btn-active)', function(e){

        e.preventDefault();
        $(this).toggleClass('btn-active');
        $(this).find(".wishlist_text").text(window.inventory_text.remove_wishlist);
        updateWishlist(this);
      }); 

      $(document).on('click', '.btn-active', function(e){
        $(this).find(".wishlist_text").text(window.inventory_text.add_wishlist);
        e.preventDefault();	
        var ProductHandle = $(self).attr('data-product-handle'),
            removeIndex = itemsArray.indexOf(ProductHandle),
            dataID = $(this).data('id');

        $('.wishlist-content .grid-item').each(function(t){
          var compareID = $(this).data('id');

          if( dataID === compareID ){
            $(this).remove();
            function showpage(page) {
              $('.wishlist-page .grid-item').hide();
              $('.wishlist-page .grid-item').eq((page-1)*3).show().next().show().next().show();
              $('#pagin').find('a').removeClass('current').eq(page).addClass('current');
            }

            pagecount = Math.floor(($('.wishlist-page .grid-item').size()) / 3);
            if (($('.wishlist-page .grid-item').size()) % 3 > 0) {
              pagecount++;
            }

            if(currentpage < 1) {currentpage = 1;}
            if(currentpage > pagecount) {currentpage = pagecount;}

            $('.wishlist-page #pagin').html('<li><a>previous</a></li>');

            for (var i = 1; i <= pagecount; i++) {
              $('#pagin').append('<li><a class="current">' + i + '</a></li>');
            }

            $('.wishlist-page #pagin').append('<li><a>next</a></li>');
            showpage(currentpage);               
          }

          if ($('.wishlist-content .grid-item').css('display') === 'block'){
            $('.wishlist-content .grid-item').eq(0).next().show().next().show();
          }
        });

        itemsArray.splice(removeIndex, 1);
        localStorage.setItem('items', JSON.stringify(itemsArray));
        $(this).removeClass('btn-active');
        le();         
      }); 

      $('.wishlist-btn').each(function () {
        var ProductHandle = $(this).attr('data-product-handle');

        if (itemsArray.indexOf(ProductHandle) > -1) {
          $(this).addClass('btn-active');
          $(this).find(".wishlist_text").text(window.inventory_text.remove_wishlist);
        }
      });
      le();
    },

    initoptionsize:function(){
      if ($(window).innerWidth() < 1025) {
        $('.option-size-dk .product-grid-options-size').remove();
      }
      else{
        $('.option-size-mb .product-grid-options-size').remove();
      }
    },
    
    cookie_popup: function() {
      $('#accept-cookies').show();
      if ($.cookie('cookieMessage') == 'closed') {
        $('#accept-cookies').remove();
      }

      $('#accept-cookies .btn').bind('click',function(){
        $('#accept-cookies').remove();
        $.cookie('cookieMessage', 'closed', {expires:1, path:'/'});
      });

      $('#accept-cookies .close').bind('click',function(){
        $('#accept-cookies').remove();
      });
    },
    
    initStickyAddtoCart: function(){

    if ($('#grouped-add-to-cart').length){
      $('.sticky_form .sticky-item.extra').remove();
    }

    var p = $('#product-selectors option:selected').val();
    var t = $('.sticky_form .pr-swatch[data-value="'+p+'"]').text();
    $('.pr-selectors .pr-active').text(t);
    $('.sticky_form .pr-swatch[data-value="'+p+'"]').addClass('active');


    $( ".swatch .swatch-element" ).each(function(e) {
      var dav = $(this).data("value");
      $('.swatch input.text[data-value="'+dav+'"]').appendTo($(this))
    });


    $( ".selector-wrapper" ).change(function() {
      var n =$("#product-selectors").val();
      $( ".sticky_form .pr-selectors li" ).each(function( e ) {
        var t =$(this).find('a').data('value');
        if(t == n){
          $(this).find('a').addClass('active')
        } else{
          $(this).find('a').removeClass('active')
        }
      });
      $( "#product-selectors" ).change(function() {
        var str = "";
        $( "#product-selectors option:selected" ).each(function() {
          str += $( this ).data('imge');
        });
        $('.sticky_form .pr-img img').attr("src",str );
      }).trigger( "change" );

      if($('.sticky_form .pr-swatch').hasClass('active')){
        var h = $('.sticky_form .pr-swatch.active').text();
        $('.sticky_form .action input[type=hidden]').val(n);
        $('.sticky_form .pr-active').text(h);
        $('.sticky_form .pr-active').attr('data-value', n);
      }

    });

    $('body').on('click touchstart', function(e){
      var container = $(".sticky_form .pr-active");
      var swatchList = container.next();
      var swatchLink = swatchList.find('a');
      if (!container.is(e.target) && container.has(e.target).length === 0 && 
          !swatchList.is(e.target) && swatchList.has(e.target).length === 0 && 
          !swatchLink.is(e.target) && swatchLink.has(e.target).length === 0){
        $('.sticky_form').removeClass('open-sticky');
      }
    });

    $('.sticky_form .pr-active').on('click', function(){
      $('.sticky_form').toggleClass('open-sticky');
    });

    $('.sticky_form .pr-swatch').on('click', function(e){  
      e.stopPropagation();
      $('.sticky_form .pr-swatch').removeClass('active');
      $(this).addClass('active');


      $('.sticky_form').toggleClass('open-sticky');


      var text = $(this).text(),
          value = $(this).data('value');

      $('.sticky_form .action input[type=hidden]').val(value);
      $('.sticky_form .pr-active').attr('data-value', value);
      $('.sticky_form .pr-active').text(text);
      $( '.swatch input.text[data-v="'+value+'"]' ).parent().find('.tric').click();

      if($(this).hasClass('sold-out')){
        $('.sticky-add-to-cart').val(window.inventory_text.sold_out).addClass('disabled').attr('disabled', 'disabled');
      }
      else{
        $('.sticky-add-to-cart').removeClass('disabled').removeAttr('disabled').val(window.inventory_text.add_to_cart);
      }

      var newImage = $(this).data('img');
      $('.pr-img img').attr({ src: newImage }); 
      return false;

    });

    $(document).on('click', '.sticky-add-to-cart', function(event) {
      event.preventDefault();
      if ($('#grouped-add-to-cart').length){
        $('#grouped-add-to-cart').click();
      }else{
        $('#product-add-to-cart').click();
      }
      return false;
    });

    var height = $('.product').outerHeight();

    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      if (scrollTop > height) {
        $('body').addClass('show_sticky');
      }
      else {
        $('body').removeClass('show_sticky');
      }
    });   


      //change qtt
      $('.sticky_form .extra .button').off('click').on('click', function(e){
        e.preventDefault();
        var oldValue = jQuery("#quantity").val(),
            newVal = 1;

        if (jQuery(this).hasClass('sticky_inc')) {
          newVal = parseInt(oldValue) + 1;
        } else if (oldValue > 1) {
          newVal = parseInt(oldValue) - 1;
        }

        jQuery("#quantity").val(newVal);
        $('.sticky_form .extra .qty-input').val(newVal);
        
        updatePricing();
      })
    },//initStickyAddtoCart

    changeQttCart: function(){
      $(".qtt-group .button").on("click", function() {

        var numInput = $(this).parent().find("input[id^='updates_']"),
            oldValue = numInput.val(),
            newVal = 1;

        if ($(this).text() == "+") {
          newVal = parseInt(oldValue) + 1;
        } else if (oldValue > 1) {
          newVal = parseInt(oldValue) - 1;
        }

        numInput.val(newVal);
      });
    }
  }

  $(document)
  .on( 'shopify:section:load', ella.product_slick )
  .on( 'shopify:section:unload', ella.product_slick );

})(jQuery);
